import React, { useEffect, useState } from 'react';
import InputField from '../Reusable/InputField';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Divider,
  Grid,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ComboReusable from '../Reusable/ComboReusable';
import { Placeholders } from '../../enums/ProductEnums';
import { SubmitButton } from '../../enums/GlobalEnums';
import { ModalForAddOrUpdateProduct } from '../../enums/ProductEnums';
import { findAllProductCategorys } from '../../actions/productCategory';
import { useDispatch } from 'react-redux';
import CaseLogo from '../Reusable/Upload-Latest/CaseLogo';

const ModalForAddProduct = ({
  handleAdd,
  handleClose,
  show,
  productReducer,
  productCategoryReducer,
}) => {
  const dispatch = useDispatch();
  const { error } = productReducer;
  const { productCategoryList } = productCategoryReducer;

  const [product, setProduct] = useState({
    productName: '',
    price: '',
    description: '',
    productCategory: {
      id: null,
    },
  });

  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    dispatch(findAllProductCategorys());
  }, []);

  const onChange = (e) => {
    const { name, value } = e.target;
    setProduct((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleComboBoxChange = (object, objectId) => {
    return (e) => {
      setProduct((prevState) => ({
        ...prevState,
        [object]: { [objectId]: e.target.value },
      }));
    };
  };

  const handleFileChangeLogo = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (event) => {
        setSelectedImage({
          id: Date.now(),
          file: file,
          name: file.name,
          preview: event.target.result,
          size: file.size,
        });
      };

      reader.readAsDataURL(file);
    }
  };

  const handleDeleteImage = () => {
    setSelectedImage(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedImage || !selectedImage.file) {
      console.error('No image selected');
      return;
    }
    let formData = new FormData();
    formData.append('productLogoImage', selectedImage.file);

    formData.append(
      'product',
      new Blob([JSON.stringify(product)], {
        type: 'application/json',
      })
    );

    handleAdd(formData);
  };

  return (
    <>
      <Dialog
        open={show}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        }}
      >
        <Box
          sx={{
            padding: '25px', // Border thickness
            borderRadius: '20px', // Rounded outer border
            background: '#7C9082',
            display: 'inline-block',
          }}
        >
          <Box
            sx={{
              backgroundColor: '#fff', // Inner content background
              padding: '24px',
              borderRadius: '0px', // Sharp corners inside
            }}
          >
            <DialogTitle>
              {ModalForAddOrUpdateProduct.titleForAddProduct}
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{ position: 'absolute', right: 55, top: 55 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <Divider
              sx={{
                border: '1px solid #7C9082 !important',
              }}
            />

            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <CaseLogo
                    onFileChange={handleFileChangeLogo}
                    selectedImage={selectedImage}
                    onDeleteImage={handleDeleteImage}
                  />
                </Grid>
                <Grid item xs={7}>
                  <InputField
                    name="productName"
                    placeholder={Placeholders.productName}
                    onChange={onChange}
                    value={product.productName}
                    error={error?.productName}
                  />

                  <InputField
                    name="price"
                    placeholder={Placeholders.price}
                    onChange={onChange}
                    value={product.price}
                    error={error?.price}
                  />

                  <InputField
                    name="description"
                    placeholder={Placeholders.description}
                    onChange={onChange}
                    value={product.description}
                    error={error?.description}
                  />

                  <ComboReusable
                    id="productCategory"
                    items={productCategoryList.map((objekat) => (
                      <option key={objekat.id} value={objekat.id}>
                        {objekat.productCategoryName}
                      </option>
                    ))}
                    onChange={handleComboBoxChange('productCategory', 'id')}
                  />

                  <DialogActions>
                    <Button
                      onClick={handleSubmit}
                      variant="contained"
                      sx={{
                        backgroundColor: '#7C9082',
                        '&:hover': {
                          backgroundColor: 'transparent',
                          color: '#7C9082',
                        },
                      }}
                    >
                      {SubmitButton.save}
                    </Button>
                  </DialogActions>
                </Grid>
              </Grid>
            </DialogContent>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default ModalForAddProduct;
